import { render } from "./ListInvites.vue?vue&type=template&id=47fd21b2&ts=true"
import script from "./ListInvites.vue?vue&type=script&lang=ts"
export * from "./ListInvites.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__